import { Component, Input } from '@angular/core';
import { SharedModule } from '@shared/modules/shared.module';

@Component({
	selector: 'app-tooltip',
	imports: [SharedModule],
	templateUrl: './tooltip.component.html',
	styleUrl: './tooltip.component.scss',
})
export class TooltipComponent {
	@Input() tooltipText = 'Texto de ayuda';
	@Input() showDelay = 500;
	@Input() hideDelay = 200;
	@Input() tooltipPosition: 'top' | 'bottom' | 'left' | 'right' = 'top';
	@Input() tooltipStyleClass = 'tooltip-custom';
}
